import client from '../../utils/api'
import { createApiAction } from '../../utils/redux-tool'

export const assist = createApiAction('notification/assist', client.create('/api/notification/assist'))
